@if (isBrowser) {
    <p-toast position="center" [baseZIndex]="5000"
             [style]="{maxHeight: '80vh', maxWidth: '90vw', width: 'auto'}"
             [preventOpenDuplicates]="true">
        <ng-template let-message pTemplate="message">
            <div class="grid grid-nogutter mt-3 w-full" [ngStyle]="{minWidth: '20vw', overflow: 'auto'}">
                <div class="col-12" style="text-align: center">
                    <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                    <h3>{{ message.summary }}</h3>
                    <p [ngStyle]="{whiteSpace: 'pre-line'}">{{ message.detail }}</p>
                </div>
                <div class="grid grid-nogutter mt-3 mb-2 col-12 justify-content-center p-fluid">
                    <div class="col-4">
                        <button abydosAutoFocus type="button" pButton pButtonLabel="OK" (click)="close()">
                            <span pButtonLabel>OK</span>
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-toast>
    <p-confirmDialog [key]="'close_query'" header="Változás történt az adatokon!"
                     message="Szeretné elmenteni az adatokat mielőtt elhagyja az oldalt?" icon="pi pi-question-circle"
                     [style]="{lineHeight: '1.5', minWidth: '25vw', maxWidth: '80vw', width: confirmDialogWidth(cd) + 'px'}"
                     [closable]="false" #cd>
        <ng-template #message let-message>
            <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
                <i [ngClass]="cd.icon" class="!text-6xl text-primary-500"></i>
                <p>{{ cd.message }}</p>
            </div>
        </ng-template>
        <ng-template #footer>
            <div class="grid justify-content-center button-min-width">
                <div class="col-12 text-center sm:col-4">
                    <p-button type="button" label="Igen" icon="pi pi-check" [style]="{width: '110px'}"
                              (click)="cd.onAccept()"></p-button>
                </div>
                <div class="col-12 sm:col-4 text-center">
                    <p-button type="button" label="Nem" styleClass="p-button-outlined" icon="pi pi-times" [style]="{width: '110px'}"
                              (click)="cd.onReject()"></p-button>
                </div>
                <div class="col-12 sm:col-4 text-center">
                    <p-button type="button" label="Mégsem" styleClass="p-button-outlined" icon="pi pi-replay" [style]="{width: '110px'}"
                              (click)="cd.hide()"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>
    <p-confirmDialog #cd2 [key]="'yes_no_only'" [header]="''" [message]="''"
                     [style]="{lineHeight: '1.5', minWidth: '25vw', maxWidth: '80vw'}"
                     [closable]="false">
        <ng-template #message let-message>
            <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
                <i [ngClass]="cd2.icon" class="!text-6xl text-primary-500"></i>
                <p>{{ cd2.message }}</p>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="grid justify-content-center button-min-width">
                <div class="col-12 sm:col-6 flex justify-content-center">
                    <p-button type="button" label="Igen" icon="pi pi-check"
                              (click)="cd2.onAccept()" [style]="{width: '140px'}"></p-button>
                </div>
                <div class="col-12 sm:col-6 flex justify-content-center">
                    <p-button type="button" label="Nem" icon="pi pi-times" [style]="{width: '140px'}" styleClass="p-button-outlined"
                              (click)="cd2.onReject()"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>
}


